import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FlowchartService {

  constructor(private http:HttpClient) { }

  GetFlowchart():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/FlowchartOperation/GetFlowchart").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetWorkflow():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/FlowchartOperation/GetWorkflow").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetForm():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/FlowchartOperation/GetForm").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetFormDetail(id:number):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/FlowchartOperation/GetFormDetail?id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetActiveWorkflow():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/FlowchartOperation/GetActiveWorkflow").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  DeleteFlowchart_Workflow(id:number):Observable<General_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/FlowchartOperation/DeleteFlowchart_Workflow?id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )

  }

  DeleteFlowchart(id:number):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/FlowchartOperation/DeleteFlowchart?id="+id).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }


  AddFormDetail(form_id: number,
    workflow_id: number):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      workflow_id:workflow_id,
      form_id:form_id,
      Token: ''
    }
    return this.http.post(environment.BaseUrl + "Daro/FlowchartOperation/AddFormDetail",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
    )

  }


}
